/**
 * Carga una imagen desde URL (blob o http) y devuelve una nueva object URL JPEG
 * rotada 90° en sentido horario o antihorario.
 */
function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
}

export type RotateDirection = "cw" | "ccw";

export async function rotateImageSrcToBlobUrl(
  imageSrc: string,
  direction: RotateDirection
): Promise<string> {
  const img = await loadImage(imageSrc);
  const iw = img.naturalWidth;
  const ih = img.naturalHeight;
  if (!iw || !ih) {
    throw new Error("Invalid image dimensions");
  }

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("No canvas context");
  }

  canvas.width = ih;
  canvas.height = iw;

  if (direction === "cw") {
    ctx.translate(ih, 0);
    ctx.rotate(Math.PI / 2);
    ctx.drawImage(img, 0, 0);
  } else {
    ctx.translate(0, iw);
    ctx.rotate(-Math.PI / 2);
    ctx.drawImage(img, 0, 0);
  }

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Empty canvas"));
          return;
        }
        resolve(URL.createObjectURL(blob));
      },
      "image/jpeg",
      0.92
    );
  });
}
